/**
 * Exporta tabela Orya para Excel (.xlsx).
 */

import * as XLSX from 'xlsx';
import { parseTableAt, stripMarkdownBold } from './relatoriosOryaMarkdownParse';
import { isCompleteTableRow } from './relatoriosOryaTableAssert';
import { formatOryaTableCellForDisplay } from './relatoriosOryaNumberFormat';

function stripCellText(value) {
  return stripMarkdownBold(
    String(value ?? '')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/&nbsp;/gi, ' ')
      .replace(/<[^>]+>/g, '')
  );
}

function parseHtmlTableForExport(html) {
  const rows = [];
  const trRe = /<tr[^>]*>([\s\S]*?)<\/tr>/gi;
  let trMatch;
  while ((trMatch = trRe.exec(html)) !== null) {
    const cells = [];
    const cellRe = /<t[dh][^>]*>([\s\S]*?)<\/t[dh]>/gi;
    let cellMatch;
    while ((cellMatch = cellRe.exec(trMatch[1])) !== null) {
      cells.push(stripCellText(cellMatch[1]));
    }
    if (cells.length) rows.push(cells);
  }
  if (rows.length < 2) return null;
  const hasHeader = /<th[\s>]/i.test(html);
  const headers = hasHeader ? rows[0] : rows[0].map((_, i) => `Coluna ${i + 1}`);
  const body = hasHeader ? rows.slice(1) : rows;
  return { headers, rows: body };
}

export function extractDisplayTableFromMarkdown(markdown) {
  const md = String(markdown || '').trim();
  if (!md) return null;

  const htmlMatch = md.match(/<table[\s\S]*?<\/table>/i);
  if (htmlMatch) {
    const parsed = parseHtmlTableForExport(htmlMatch[0]);
    if (parsed?.headers?.length && parsed.rows?.length) {
      return {
        headers: parsed.headers.map(stripCellText),
        rows: parsed.rows.map((row) =>
          parsed.headers.map((h, ci) =>
            formatOryaTableCellForDisplay(stripCellText(row[ci]), h)
          )
        ),
      };
    }
  }

  const lines = md.split(/\r?\n/);
  for (let i = 0; i < lines.length; i += 1) {
    const table = parseTableAt(lines, i);
    if (!table?.headers?.length) continue;

    const headers = table.headers.map(stripCellText);
    const rows = [];
    for (const row of table.rows || []) {
      const padded = [...row];
      while (padded.length < headers.length) padded.push('');
      const slice = padded.slice(0, headers.length);
      if (!isCompleteTableRow(headers, slice)) continue;
      rows.push(
        headers.map((h, ci) => formatOryaTableCellForDisplay(stripCellText(slice[ci]), h))
      );
    }
    if (rows.length) return { headers, rows };
  }

  return null;
}

export function downloadOryaTableXlsx(headers, rows, filename = 'orya-resultado.xlsx') {
  if (!headers?.length) return;
  const matrix = [headers, ...(rows || [])];
  const ws = XLSX.utils.aoa_to_sheet(matrix);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Orya');
  XLSX.writeFile(wb, filename);
}

export function downloadOryaMarkdownTableXlsx(markdown, filename = 'orya-tabela.xlsx') {
  const table = extractDisplayTableFromMarkdown(markdown);
  if (!table) return;
  downloadOryaTableXlsx(table.headers, table.rows, filename);
}
